export default "__VITE_ASSET__BKbLZ0_2__"